import { HttpHeaders } from '@angular/common/http';

export interface HttpResponseMetadata {
  headers: HttpHeaders;
  httpStatusCode: number;
  trackingHelper?: string;
}

const httpResponseMetadata = new WeakMap<object, HttpResponseMetadata>();

export function setHttpResponseMetadata(responseBody: unknown, metadata: HttpResponseMetadata): void {
  if (!responseBody || typeof responseBody !== 'object') {
    return;
  }

  httpResponseMetadata.set(responseBody, metadata);
}

export function getHttpResponseMetadata(responseBody: unknown): HttpResponseMetadata | undefined {
  if (!responseBody || typeof responseBody !== 'object') {
    return undefined;
  }

  return httpResponseMetadata.get(responseBody);
}
